import { getMrqData } from "../../api";

export const ifMrqUrl = async ({
  mrqId,
  setSelectedMrqData,
  setMrqSelection,
}) => {
  const mrq = await getMrqData(mrqId);

  setSelectedMrqData(mrq);
};
